import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { fillPlaceholders } from '@skylab-shared/utils';

export interface NumberingLinkedWithSalePattern {
    readonly id: number;
    readonly name: string;
    readonly status: 'Active' | 'Inactive' | 'Expired';
}

export class NumberingLinkedWithSalePatternQuery extends Query<NumberingLinkedWithSalePattern[]> {
    public constructor(public readonly id: number) {
        super();
    }
}

export class NumberingLinkedWithSalePatternQueryHandlerBase implements QueryHandler<NumberingLinkedWithSalePatternQuery> {
    private static Url = TaggedUrl.join('system/numberings/:id/documentTemplates', [Tags.Api]);

    public constructor(
        private readonly http: HttpService
    ) { }

    public async handleAsync(params: NumberingLinkedWithSalePatternQuery): Promise<NumberingLinkedWithSalePattern[]> {
        const url = fillPlaceholders(NumberingLinkedWithSalePatternQueryHandlerBase.Url, { id: params.id });
        const { data } = await this.http.get<NumberingLinkedWithSalePattern[]>(url);
        return data;
    }
}
